import { helper } from "@ember/component/helper"
import { get } from "@ember/object"
import type { Classification } from "@shared/models/classifications"
import { includes, isNil } from "lodash-es"

export function hasClassification(args: [any, Classification]) {
  let [model, classification] = args
  if (isNil(model)) return false
  return includes(get(model, "attributes.classifications"), classification)
}

const hasClassificationHelper = helper(hasClassification)
export default hasClassificationHelper

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "has-classification": typeof hasClassificationHelper
  }
}
